import Modal from "components/Modal/Modal";
import { useSelector } from "react-redux";
import {
  deleteIncident,
  deleteIncidentById,
  selectIncidentForDeletion,
  selectState,
  setDeleteIncidentModalOpen
} from "../incident.slice";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";
import { IOption } from "Dashboard/domain/IOption";

interface IProps {
  incidentTypes: IOption[] | undefined;
}

const DeleteIncidentModal = ({ incidentTypes }: IProps) => {
  const { deleteIncidentModalOpen } = useSelector(selectState);
  const incident = useSelector(selectIncidentForDeletion);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeleteIncidentModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      await dispatch(deleteIncident(incident.incidentId));
      dispatch(deleteIncidentById(incident.incidentId));
      toast.success("Uspešno obrisan.");
      close();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deleteIncidentModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje incidenta">
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeći incident:
        <br />
        <br />
        <b>{incidentTypes !== undefined &&
          incidentTypes.find(e => e.value === incident?.incidentTypeId)?.label} ?</b>
      </p>
    </Modal>
  )
};

export default DeleteIncidentModal;
